/**
 * A name candidate offered by `SupplierNamePicker`: one backed by a resolved supplier entity, or
 * a free-typed name (`entityId === null`).
 */
export type SupplierNameOption = {
    entityId: number | null;
    name: string;
    /** Muted text after the name — e.g. which cluster a raw row currently sits in. */
    hint?: string;
    /** Set on the `+ Add "…"` row, which only appears when the picker allows adding. */
    isNew?: boolean;
};

/** Identity of a candidate, so "did this change?" compares the resolved entity as well as the name. */
export function supplierNameOptionKey(option: SupplierNameOption): string {
    return `${option.entityId ?? ''}|${option.name.trim()}`;
}
